import React, { useEffect, useState } from "react";

import { FOOTER_URL } from "@constants/api.urls";
import { USER_INFO } from "@constants/global.constants";

import { combineClassNames } from "@utils/appUtils";

import IconButton from "@components/IconButton";
import { CollapseImageIcon, ExpandImageIcon } from "@components/SVGs";
import { WPTypogrpahy } from "@components/WPTypography";

import AccordionDownArrowIcon from "@common/icons/AccordionDownArrowIcon";

import {
  accessSetupImages,
  imageEndIdx,
  imageStartIdx,
  WPEditProfileStepsPageConstants,
} from "../../features/WPAccessDeniedPage/WPAccessDeniedPage.constants";

import "./WPEditProfileStepsPage.scss";

const WPEditProfileStepsPage = ({ isEnable, termsLanguage }) => {
  const [expandedImageIdx, setExpandedImageIdx] = useState(null);
  const handleExpand = idx => () => setExpandedImageIdx(idx);
  const handleCollapse = () => setExpandedImageIdx(null);

  // This effect is added to prevent the background page from scrolling when image is enlarged
  useEffect(() => {
    if (expandedImageIdx !== null) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [expandedImageIdx]);

  const translatedAccessDeniedConstants = React.useMemo(
    () => WPEditProfileStepsPageConstants(termsLanguage),
    [termsLanguage],
  );

  const handleIconClick = () => {
    isEnable(false);
  };
  const language = termsLanguage || USER_INFO.cultureName;
  return (
    <>
      <div className='item-container content-wrapper'>
        <div className='instructions-wrapper'>
          <div className='wavepro-access-card'>
            <div className='title-description-wrapper'>
              <span className='accordion-icon' onClick={handleIconClick}>
                <AccordionDownArrowIcon />
              </span>
              <div className='text-block'>
                <WPTypogrpahy
                  text={translatedAccessDeniedConstants.title}
                  className='mb-2 wrap-text'
                  fontWeight={600}
                />
                <WPTypogrpahy
                  color='var(--du-color-black_70)'
                  text={translatedAccessDeniedConstants.description}
                  className='mb-4 wrap-text'
                />
              </div>
            </div>
            <ol type='1'>
              {translatedAccessDeniedConstants.steps.map((step, index) => (
                <li key={index}>
                  <div className='instruction-info'>
                    <div className='instruction-line'>
                      <WPTypogrpahy
                        text={step.instruction}
                        color='var(--du-color-black_70)'
                        className='inline-text wrap-text'
                      />
                      {step.linkText && (
                        <span
                          className='inline-link'
                          onClick={() => window.open(FOOTER_URL[language].dupontUrl, "_blank")}
                          role='button'
                        >
                          {step.linkText}
                        </span>
                      )}
                    </div>
                    {index > imageStartIdx && index <= imageEndIdx && (
                      <>
                        {expandedImageIdx !== index && (
                          <div className='instruction-image'>
                            <img
                              src={accessSetupImages(termsLanguage)[index - 1].src}
                              alt={accessSetupImages(termsLanguage)[index - 1].alt}
                              className='access-steps-image'
                              onClick={handleExpand(index)}
                            />
                            <IconButton
                              tooltip={translatedAccessDeniedConstants.clickToExpand}
                              onClick={handleExpand(index)}
                              className='enlarge-collapse-btn'
                              id={`expand-btn-${index}`}
                              name={`expand-btn-${index}`}
                            >
                              <ExpandImageIcon />
                            </IconButton>
                          </div>
                        )}
                        {expandedImageIdx === index && (
                          <div className='image-enlarged-overlay flex-center' onClick={handleCollapse}>
                            <div
                              className={combineClassNames("image-wrapper", "position-relative")}
                              onClick={event => event.stopPropagation()}
                            >
                              <img
                                src={accessSetupImages(termsLanguage)[index - 1].src}
                                alt={accessSetupImages(termsLanguage)[index - 1].alt}
                                className='access-image-enlarged'
                              />
                              <IconButton
                                tooltip={translatedAccessDeniedConstants.clickToCompress}
                                onClick={handleCollapse}
                                className='enlarge-collapse-btn'
                                id={`collapse-btn-${index}`}
                                name={`collapse-btn-${index}`}
                              >
                                <CollapseImageIcon />
                              </IconButton>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default WPEditProfileStepsPage;
